module.exports = __webpack_public_path__ + "media/videos/term-bg-5-e467362c.jpg";